// @ts-expect-error: no types
import ResolveReferences from 'reference-resolvers/ResolveReferences';
//@ts-expect-error Missing types
import { COS_INDEX_CONNECTIONS_PARENTS } from 'reference-resolvers/constants/ReferenceObjectTypes';
const ResolveReferencesToCosIndexConnectionsParents = ({
  target,
  mapPropsToFormIds
}) => {
  return ResolveReferences((resolvers, props) => {
    const resolver = resolvers[COS_INDEX_CONNECTIONS_PARENTS];
    const formIds = mapPropsToFormIds(props);
    const cosIndexObjectAtoms = formIds.map(formId => resolver.byId(formId));
    return {
      cosIndexObjectReferenceRecords: cosIndexObjectAtoms
    };
  })(target);
};
export default ResolveReferencesToCosIndexConnectionsParents;